import { AffiliateForm } from "./AffiliateForm";

export { AffiliateForm };
